import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth";
import series from "./series";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { auth, series },
});
